import msCombobox from "./MsCombobox";

export default {
    name: "msComboboxEnum",
    extends: msCombobox,
    props: {
        enum: {
            default: null,
            type: String
        },
        /**
         * @override
         */
        valueField: {
            type: String,
            default: "enumValue"
        },
        /**
         * @override
         */
        displayField: {
            type: String,
            default: "enumText"
        },
        values: {
            type: Array,
            default: null
        },
    },
    created() {
        this.loadEnumSource();
    },
    mounted() {
    },
    methods: {
        loadEnumSource() {
            const me = this;

            let source = me.$ms.commonFn.getEnumSource(me.enum, me.values);
            me._allData = source;
        }
    }
};